import { useLocation } from 'react-router-dom';

import { PageTypes } from '@Enum/PageTypes.enum';

const getPageType = (pathname: string): string | undefined => {
  if (pathname.includes('edit') && pathname.includes('manage-requests')) {
    return PageTypes.EDIT_MY_REQUEST;
  }

  if (pathname.includes('create') && pathname.includes('manage-requests')) {
    return PageTypes.CREATE_MY_REQUEST;
  }

  // such if condition must be after edit/create checks
  if (pathname.includes('manage-requests')) {
    return PageTypes.MY_REQUESTS;
  }

  if (pathname.includes('approve-form')) {
    return PageTypes.RESPOND_TASK;
  }

  // such if condition must be after approve-task check
  if (pathname.includes('approvals')) {
    return PageTypes.APPROVALS;
  }

  if (pathname.includes('procurement') && pathname.includes('create')) {
    return PageTypes.CREATE_PROCUREMENT;
  }

  if (pathname.includes('procurement') && pathname.includes('edit')) {
    return PageTypes.EDIT_PROCUREMENT;
  }

  if (pathname.includes('procurement')) {
    return PageTypes.PROCUREMENT;
  }

  if (pathname.includes('dashboard')) {
    return PageTypes.DASHBOARD;
  }

  return undefined;
};

export const usePageType = (): string | undefined => {
  const { pathname } = useLocation();

  const pageType = getPageType(pathname);

  return pageType;
};
